import * as rd from '@devexperts/remote-data-ts'
import { createSelector } from '@reduxjs/toolkit'
import { licenseSlice } from '..'

export const isLoadingLicenseStringSelector = createSelector(
  [licenseSlice.selectors.strings],
  rd.isPending
)
